import React from 'react';

interface ResourcePermissionsProps {
  resourceName: string;
  resource: string;
  permissions: string[];
  onChange: (actions: string[]) => void;
  disabled?: boolean;
}

export const ResourcePermissions: React.FC<ResourcePermissionsProps> = ({
  resourceName,
  resource: _resource,
  permissions,
  onChange,
  disabled = false,
}) => {
  const handlePermissionChange = (action: string, value: boolean) => {
    if (disabled) {
      return;
    }

    console.log('Permission change:', {
      action,
      value,
      currentPermissions: permissions,
    });

    if (value) {
      if (!permissions.includes(action)) {
        const newPermissions = [...permissions, action];
        onChange(newPermissions);
      }
    } else {
      const newPermissions = permissions.filter(a => a !== action);
      onChange(newPermissions);
    }
  };

  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-lg p-4">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-medium text-gray-800 dark:text-white">
          {resourceName}
        </h4>
        {disabled && (
          <span className="text-xs text-gray-500 bg-gray-100 dark:bg-gray-700 px-2 py-1 rounded">
            Read Only
          </span>
        )}
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={permissions.includes('read')}
            onChange={e => handlePermissionChange('read', e.target.checked)}
            disabled={disabled}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">Read</span>
        </label>

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={permissions.includes('create')}
            onChange={e => handlePermissionChange('create', e.target.checked)}
            disabled={disabled}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Create
          </span>
        </label>

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={permissions.includes('update')}
            onChange={e => handlePermissionChange('update', e.target.checked)}
            disabled={disabled}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Update
          </span>
        </label>

        <label className="flex items-center space-x-2">
          <input
            type="checkbox"
            checked={permissions.includes('delete')}
            onChange={e => handlePermissionChange('delete', e.target.checked)}
            disabled={disabled}
            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-300">
            Delete
          </span>
        </label>
      </div>

      {/* Показуємо статус дозволів */}
      <div className="mt-3 flex items-center space-x-4 text-xs">
        <span
          className={`px-2 py-1 rounded ${
            permissions.includes('read')
              ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
              : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
          }`}
        >
          View: {permissions.includes('read') ? 'Yes' : 'No'}
        </span>
        <span
          className={`px-2 py-1 rounded ${
            permissions.includes('create') || permissions.includes('update')
              ? 'bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-200'
              : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
          }`}
        >
          Edit:{' '}
          {permissions.includes('create') || permissions.includes('update')
            ? 'Yes'
            : 'No'}
        </span>
        <span
          className={`px-2 py-1 rounded ${
            permissions.includes('delete')
              ? 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
              : 'bg-gray-100 text-gray-600 dark:bg-gray-800 dark:text-gray-400'
          }`}
        >
          Delete: {permissions.includes('delete') ? 'Yes' : 'No'}
        </span>
      </div>
    </div>
  );
};
